<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="700px"
  >
    <v-card>
      <v-card-title>
        <span>Hỗ trợ kỹ thuật</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-tabs
              v-model="tabs"
              grow
              show-arrows
            >
              <v-tabs-slider/>
              <v-tab>
                Thông tin liên hệ
              </v-tab>
              <v-tab>
                Xử lý lỗi
              </v-tab>
              <v-tab-item class="mt-4">
                <v-row>
                  <v-col cols="12">
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold">Hotline:</v-list-item-content>
                        <v-list-item-content class="align-end">
                          {{ hotline }}
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content class="font-weight-bold">Zalo:</v-list-item-content>
                        <v-list-item-content class="align-end">
                          <a :href="`http://zalo.me/${zalo}`">
                            Mở ứng dụng
                          </a>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item class="mt-4">
                <v-row>
                  <v-col cols="12">
                    <v-alert
                      text
                      type="warning"
                      icon="mdi-alert"
                    >
                      Thử <v-btn x-small>Shift</v-btn> + <v-btn x-small>F5</v-btn> để tải lại trang trong trường hợp bị ảnh hưởng bởi bộ đệm web
                    </v-alert>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        tabs: 0,
        dialog: false,
      }
    },
    computed: {
      ...mapState({
        hotline: state => state.config.support.hotline,
        zalo: state => state.config.support.zalo
      })
    },
    watch: {
      showDialog() {
        this.dialog = false;
        if (this.showDialog) {
          this.dialog = true;
        }
      }
    },
    methods: {
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      }
    }
  }
</script>